import {TypeaheadService} from '../../typeahead/typeahead.service'
import * as $ from 'jquery';

export class ProductDetailColorSearchCommon {

    public static init() {
        if($('input#colorCode').length>0){
            TypeaheadService.setupTypeaheadLocal('input#colorCode',
                (window as any).colorPalette,
                'name',
                false,
                null,
                null,
                data => {
                    return `<div class="product-select-option" onclick="drawColorDetail('${data.name}')">${data.name}</div>`;
                });
        }



    }

    private static openResults(ev) {
        console.log(ev);
        let query = $(ev.target).closest('.search-container').find('input#findProduct').val();

        if (query) {
            location.href = `/products/search_results?q=${query}`;
        }
    }
}